import $ from 'jquery'
import React from 'react'
import { Component } from 'react'


class ZitatLoading extends Component {


    render() {

        return (
            <div className="zitat grid-x placeholder-content" id="z-load">
                <div className="small-8 cell">

                    <div className="metapher placeholder-content-item">............................................................
        </div>
                    <div className="metapher-types placeholder-content-item">..................................................................................</div>
                    <div>
                        <div className="text placeholder-content-item">................................................</div>
                        <div className=" placeholder-content-item">............................................................</div>
                    </div>
                    <div>
                        <div className=" placeholder-content-item">............................................................</div>
                        <div className="tree-list">
                            <div className="branch"><a className="search-link placeholder-content-item">....................................................................................................</a>
                                <div className="tree-list">
                                    <div className="branch"><a className="search-link placeholder-content-item">.......................................................................................</a>
                                        <div className="tree-list"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="branch"><a className="search-link placeholder-content-item">............................................................</a>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="small-4 cell"><div className="things">
                    <div className="thing">
                        <div className="title">
                            <div className="name"><a className="search-link placeholder-content-item">.............................</a></div>

                        </div>
                        <ul className="properties">
                            <li className="property"><span className="category placeholder-content-item">...................</span><span className="value">
                                <div className="tree-list">
                                    <div className="branch"><a className="search-link placeholder-content-item">......................</a>
                                        <div className="tree-list"></div>
                                    </div>
                                </div>
                            </span></li>
                            <li className="property"><span className="category placeholder-content-item">............................</span><span className="value">
                                <div className="tree-list">
                                    <div className="branch"><a className="search-link placeholder-content-item">...................</a>
                                        <div className="tree-list">
                                            <div className="branch"><a className="search-link placeholder-content-item">................................</a>
                                                <div className="tree-list"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span></li>
                            <li className="property"><span className="category placeholder-content-item">......................</span><span className="value">
                                <div className="tree-list">
                                    <div className="branch"><a className="search-link placeholder-content-item">...................</a>
                                        <div className="tree-list">
                                            <div className="branch"><a className="search-link placeholder-content-item">.............................</a>
                                                <div className="tree-list"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span></li>
                            <li className="property"><span className="category placeholder-content-item">.........................</span><span className="value">
                                <div className="tree-list">
                                    <div className="branch"><a className="search-link placeholder-content-item">.............................</a>
                                        <div className="tree-list"></div>
                                    </div>
                                </div>
                            </span></li>
                        </ul>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}


export default ZitatLoading


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/loading/ZitatLoading.js